'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TERM_TO_BUTTON_I18N_;

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _UILoadingButton = require('UIComponents/button/UILoadingButton');

var _UILoadingButton2 = _interopRequireDefault(_UILoadingButton);

var _TermIds = require('self-service-api/constants/TermIds');

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _ImmutableTermIdMap = require('self-service-api/constants/ImmutableTermIdMap');

var _ImmutableTermIdMap2 = _interopRequireDefault(_ImmutableTermIdMap);

var _ImmutableProductBasedOfferIdMap = require('self-service-api/constants/ImmutableProductBasedOfferIdMap');

var _ImmutableProductBasedOfferIdMap2 = _interopRequireDefault(_ImmutableProductBasedOfferIdMap);

var _MerchandiseIdLists = require('self-service-api/constants/MerchandiseIdLists');

var _upgradeDataPropsInterface = require('ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface');

var _CheckoutPropsInterface = require('ui-addon-upgrades/_core/checkout/CheckoutPropsInterface');

var _tracker = require('ui-addon-upgrades/_core/common/eventTracking/tracker');

var tracker = _interopRequireWildcard(_tracker);

var _url = require('ui-addon-upgrades/_core/common/navigation/url');

var _links = require('ui-addon-upgrades/_core/common/navigation/links');

var _generatePurchaseOrder = require('ui-addon-upgrades/_core/checkout/generatePurchaseOrder');

var _AdminOnlyWrapper = require('ui-addon-upgrades/_core/common/components/AdminOnlyWrapper');

var _AdminOnlyWrapper2 = _interopRequireDefault(_AdminOnlyWrapper);

var _AdminTypes = require('ui-addon-upgrades/_core/common/constants/AdminTypes');

var _AdminModalTypes = require('ui-addon-upgrades/_core/common/constants/AdminModalTypes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TERM_TO_BUTTON_I18N_KEY = (_TERM_TO_BUTTON_I18N_ = {}, _defineProperty(_TERM_TO_BUTTON_I18N_, _TermIds.MONTHLY_NO_DISCOUNT, 'monthly'), _defineProperty(_TERM_TO_BUTTON_I18N_, _TermIds.MONTHLY_25_PERCENT_DISCOUNT, 'monthly'), _defineProperty(_TERM_TO_BUTTON_I18N_, _TermIds.MONTHLY_50_PERCENT_DISCOUNT, 'monthly'), _defineProperty(_TERM_TO_BUTTON_I18N_, _TermIds.ANNUAL_NO_DISCOUNT, 'annual'), _defineProperty(_TERM_TO_BUTTON_I18N_, _TermIds.ANNUAL_20_PERCENT_DISCOUNT, 'annual'), _defineProperty(_TERM_TO_BUTTON_I18N_, _TermIds.ANNUAL_25_PERCENT_DISCOUNT, 'annual'), _defineProperty(_TERM_TO_BUTTON_I18N_, _TermIds.ANNUAL_60_PERCENT_DISCOUNT, 'annual'), _TERM_TO_BUTTON_I18N_);

var CheckoutButton = function (_React$Component) {
  _inherits(CheckoutButton, _React$Component);

  function CheckoutButton(props) {
    _classCallCheck(this, CheckoutButton);

    var _this = _possibleConstructorReturn(this, (CheckoutButton.__proto__ || Object.getPrototypeOf(CheckoutButton)).call(this, props));

    _this.state = {
      lastOrderGenerationFailed: false,
      isGeneratingPurchaseOrder: false
    };

    _this.handleClick = _this.handleClick.bind(_this);
    _this.onOrderGenerationFailed = _this.onOrderGenerationFailed.bind(_this);
    return _this;
  }

  _createClass(CheckoutButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var upgradeData = this.props.upgradeData;


      tracker.track('checkoutButtonInteraction', _extends({
        action: 'viewed'
      }, upgradeData, this.getCheckoutButtonInteractionTrackingProperties()));
    }
  }, {
    key: 'getMerchandiseIds',
    value: function getMerchandiseIds() {
      var itemConfigurations = this.props.itemConfigurations;

      return itemConfigurations.map(function (_ref) {
        var merchandiseId = _ref.merchandiseId;
        return merchandiseId;
      });
    }
  }, {
    key: 'getCheckoutButtonInteractionTrackingProperties',
    value: function getCheckoutButtonInteractionTrackingProperties() {
      var _props = this.props,
          termId = _props.termId,
          currencyCode = _props.currencyCode,
          itemConfigurations = _props.itemConfigurations,
          productBasedOffers = _props.productBasedOffers,
          additionalUnitQuantity = _props.additionalUnitQuantity;


      var merchandiseIds = this.getMerchandiseIds();
      var merchandiseNames = merchandiseIds.map(function (merchId) {
        return _ImmutableMerchandiseIdMap2.default[merchId].trackingName;
      });
      var productBasedOfferNames = productBasedOffers.map(function (offerId) {
        return _ImmutableProductBasedOfferIdMap2.default[offerId].trackingName;
      });
      var isQuantityUpgrade = itemConfigurations.length === 1 && _MerchandiseIdLists.QUANTITY_MERCHANDISE_IDS.indexOf(itemConfigurations[0]) !== -1;

      var trackingProps = {
        additionalUnitQuantity: additionalUnitQuantity,
        currencyCode: currencyCode,
        merchandiseIds: merchandiseIds,
        merchandiseNames: merchandiseNames,
        productBasedOfferIds: productBasedOffers,
        productBasedOfferNames: productBasedOfferNames,
        isQuantityUpgrade: isQuantityUpgrade,
        termId: termId
        // TODO: Add quantity if quantity upgrade?
      };

      if (termId) {
        trackingProps = _extends({}, trackingProps, {
          termId: termId,
          termName: _ImmutableTermIdMap2.default[termId].trackingName
        });
      }

      return trackingProps;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      var _this2 = this;

      var _props2 = this.props,
          termId = _props2.termId,
          currencyCode = _props2.currencyCode,
          itemConfigurations = _props2.itemConfigurations,
          productBasedOffers = _props2.productBasedOffers,
          onClick = _props2.onClick;


      onClick();

      this.onOrderGenerationStart(e);

      (0, _generatePurchaseOrder.generatePurchaseOrder)(termId, currencyCode, itemConfigurations, productBasedOffers).then(function (orderId) {
        _this2.onOrderGenerationComplete();
        (0, _url.navigateTo)((0, _links.checkout)(orderId));
      }).catch(this.onOrderGenerationFailed);
    }
  }, {
    key: 'onOrderGenerationStart',
    value: function onOrderGenerationStart(e) {
      var _props3 = this.props,
          upgradeData = _props3.upgradeData,
          onClick = _props3.onClick;


      this.setState({
        lastOrderGenerationFailed: false,
        isGeneratingPurchaseOrder: true
      });

      tracker.track('checkoutButtonInteraction', _extends({
        action: 'clicked'
      }, upgradeData, this.getCheckoutButtonInteractionTrackingProperties()));

      if ((0, _underscore.isFunction)(onClick)) {
        onClick(e);
      }
    }
  }, {
    key: 'onOrderGenerationComplete',
    value: function onOrderGenerationComplete() {
      var upgradeData = this.props.upgradeData;


      this.setState({
        lastOrderGenerationFailed: false,
        isGeneratingPurchaseOrder: false
      });

      tracker.track('checkoutButtonInteraction', _extends({
        action: 'purchase order generated'
      }, upgradeData, this.getCheckoutButtonInteractionTrackingProperties()));
    }
  }, {
    key: 'onOrderGenerationFailed',
    value: function onOrderGenerationFailed(err) {
      var _props4 = this.props,
          onError = _props4.onError,
          upgradeData = _props4.upgradeData;


      if ((0, _underscore.isFunction)(onError)) {
        onError(err);
      }

      this.setState({
        lastOrderGenerationFailed: true,
        isGeneratingPurchaseOrder: false
      });

      tracker.track('checkoutButtonInteraction', _extends({
        action: 'purchase order generation failed'
      }, upgradeData, this.getCheckoutButtonInteractionTrackingProperties()));
    }
  }, {
    key: 'renderButtonText',
    value: function renderButtonText() {
      var termId = this.props.termId;

      var termRelatedI18nKey = TERM_TO_BUTTON_I18N_KEY[termId];

      if (termRelatedI18nKey) {
        return _react2.default.createElement(_FormattedMessage2.default, {
          message: 'upgrades.checkoutButton.' + termRelatedI18nKey
        });
      }

      return _react2.default.createElement(_FormattedMessage2.default, { message: 'upgrades.checkoutButton.default' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          lastOrderGenerationFailed = _state.lastOrderGenerationFailed,
          isGeneratingPurchaseOrder = _state.isGeneratingPurchaseOrder;

      var merchandiseId = (0, _underscore.last)(this.getMerchandiseIds()) || null;
      var propsToPass = (0, _underscore.omit)(this.props, ['children', 'upgradeData', 'onError', 'termId', 'currencyCode', 'itemConfigurations', 'productBasedOffers', 'onClick', 'allowModal', 'additionalUnitQuantity']);

      return _react2.default.createElement(
        _AdminOnlyWrapper2.default,
        {
          adminType: _AdminTypes.BILLING,
          merchandiseId: merchandiseId,
          modalType: _AdminModalTypes.REQUEST_SKU
        },
        _react2.default.createElement(
          _UILoadingButton2.default,
          _extends({}, propsToPass, {
            failed: lastOrderGenerationFailed,
            loading: isGeneratingPurchaseOrder,
            onClick: this.handleClick,
            'data-selenium': 'checkout-button',
            'data-reagan-primary-cta': true
          }),
          this.props.children || this.renderButtonText()
        )
      );
    }
  }]);

  return CheckoutButton;
}(_react2.default.Component);

CheckoutButton.defaultProps = {
  use: 'primary',
  productBasedOffers: [],
  onClick: function onClick() {}
};

CheckoutButton.propTypes = _extends({}, _upgradeDataPropsInterface.upgradeDataPropsInterface, _CheckoutPropsInterface.CheckoutButtonPropsInterface);

exports.default = CheckoutButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/checkout/CheckoutButton.js
// module id = 582
// module chunks = 3 4 5